import { Pagination, InputNumber, Button } from "antd"
import { useState } from "react"
import styles from '@/styles/pagination.module.scss'

interface propsVoid {
  pages: number,
  pageSize: number,
  total: number,
  onChange?: Function
  showQuickJumper?: boolean
  hideOnSinglePage?: boolean
  showSizeChanger?: boolean
}

export default function CustomPagination(props: propsVoid) {

  const [currentPage, setCurrentPage] = useState<string | number | null>(1);

  const skipJumper = () => {
    props.onChange && props.onChange(currentPage, props.pageSize)
  }
  return (
    <>
      <div className={styles['custom-pagination']}>
        <Pagination
          className={styles['pagination']}
          current={props.pages}
          pageSize={props.pageSize}
          total={props.total}
          onChange={(page: number, pageSize: number) => { props.onChange && props.onChange(page, pageSize) }}
          hideOnSinglePage={props.hideOnSinglePage}
          showSizeChanger={props.showSizeChanger}
        />

        {
          (!!props.showQuickJumper && props.total / props.pageSize > 1)
          &&
          <>
            <span className={styles['jumper-text']}>To Page:</span>
            <InputNumber
              className={styles['jumper-input']}
              min={1}
              max={parseInt(`${props.total / props.pageSize}`) + 1}
              value={currentPage}
              onChange={setCurrentPage}
              onPressEnter={skipJumper}
              controls={false}
            />
            <Button className={styles['jumper-btn']} onClick={skipJumper}>Skip</Button>
          </>
        }


      </div>
    </>
  )
}